module.exports = __webpack_public_path__ + "static/img/cont3615.3229613.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3615.jpg
// module id = lSiY
// module chunks = 0